import script from "./SOWReportingServiceProvider.vue?vue&type=script&lang=ts&setup=true"
export * from "./SOWReportingServiceProvider.vue?vue&type=script&lang=ts&setup=true"

import "./SOWReportingServiceProvider.vue?vue&type=style&index=0&id=5bede690&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bede690"]])

export default __exports__